import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { NameDto, ShortNameDto } from './NameDto'
import { TwoFAProviderEnum } from './TwoFactorAuthentication'

export interface AuthUser {
  accessToken: string
  dateFormatType: NameDto<number>
  email: string
  expires: number
  firstName: string
  forceUpdateCredentials: boolean
  id: string
  impersonatorId?: string
  isCompromised: boolean
  kind: 'client'
  lastName: string
  refreshToken: string
  roles: []
  sessionId: string
  teams: []
  tickmillCompany: ShortNameDto<TickmillCompaniesEnum>
  twoFactor: TwoFactor[] | null
}

export const isImpersonatedSession = (auth: AuthUser | null): boolean => {
  return !!auth?.impersonatorId
}

export interface TwoFactor {
  token: string
  provider: NameDto<TwoFAProviderEnum>
  typeId?: TwoFAProviderEnum
  authMedium: string
  remainingResendCodeAttemptsCount: number
}

export interface LoginResponse {
  accessToken: string | null
  dateFormatType: NameDto<number> | null
  email: string
  expires: number
  firstName: string | null
  lastName: string | null
  forceUpdateCredentials: boolean
  id: string
  impersonatorId?: string
  kind: 'client' | null
  refreshToken: string | null
  roles: [] | null
  sessionId: string | null
  teams: [] | null
  departments: [] | null
  trustDeviceToken: string | null
  tickmillCompany: ShortNameDto<TickmillCompaniesEnum> | null
  twoFactor: TwoFactor[] | null
  isCompromised: boolean
}

export interface TrustDeviceResponse {
  id: string
  isDeviceTrusted: boolean
  trustUserDeviceToken: string
  message: string | null
}
